import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { Combinator } from 'modules/queryBuilder/types';

export const useGetAdditionalConditionPretext = () => {
  const { t } = useTranslation();
  return (index: number, combinator: Combinator, isUserEvent: boolean) => {
    if (index === 0 && !isUserEvent) return t('storybook.layouts.condition.pretext.where');
    switch (combinator) {
      case Combinator.AND:
        return t(`storybook.layouts.condition.pretext.and`);
      case Combinator.OR:
        return t(`storybook.layouts.condition.pretext.or`);
      case Combinator.NOT:
        return t(`storybook.layouts.condition.pretext.not`);
      default:
        return ''; // shouldn't hit this case
    }
  };
};
